import React, { useState } from 'react'
import '../../cssHelper/helper.css'
import './Frame.css'
import Sidebar from '../Sidebar/Sidebar'
import Header from '../Header/Header'
import Hero from '../Hero/Hero'
import Video from '../Video/Video'
import Suggession from '../Suggession/Suggession'
import SearchResults from '../SearchResults/SearchResults'
import { useSelector } from 'react-redux'

function Frame() {
  const query = useSelector((state) => state.youtube.query)
  const play = useSelector((state) => state.youtube.play)
  return (
    <div className='Frame flex size-full black-bg white-clr scroll-hidden'>
      {play ? <Video /> : ''}
      <Sidebar />
      <difv className="body flex flex-col">
        <Header />
        <div className="categories-suggesions-w-full p-inline-3 pb-3">
          <Suggession />
        </div>
        <div className="hero-container w-full scroll-hidden mt">
          {
            query != '' ? <SearchResults /> : <Hero />
          }
        </div>
      </difv>

    </div>
  )
}

export default Frame
